import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=ab42a1b6&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ebenhafkamp/Documents/Projects/tacpro/src/webpack/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab42a1b6')) {
      api.createRecord('ab42a1b6', component.options)
    } else {
      api.reload('ab42a1b6', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=ab42a1b6&", function () {
      api.rerender('ab42a1b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/Tabs.vue"
export default component.exports